package components.assemblyPortfolio

import components.userName
import it.neckar.lizergy.model.assemblyPortfolio.ResolvedAssemblyPortfolio
import it.neckar.lizergy.model.company.UserResolver
import it.neckar.lizergy.model.company.user.UserInformation
import it.neckar.lizergy.model.configuration.quote.QuoteConfiguration
import it.neckar.lizergy.model.project.ResolvedProject
import it.neckar.open.formatting.dateFormat
import it.neckar.open.formatting.timeFormat
import it.neckar.open.time.nowMillis
import it.neckar.react.common.*
import it.neckar.react.common.button.*
import it.neckar.react.common.router.*
import plannerI18nConfiguration
import react.*
import react.dom.*
import react.router.dom.*
import router.RouterUrls
import services.UiActions

fun RBuilder.assemblyPortfolioDownloadButtons(
  project: ResolvedProject,
  currentConfiguration: QuoteConfiguration?,
  downloadAssemblyPortfolioBusy: Boolean,
  setDownloadAssemblyPortfolioBusy: StateSetter<Boolean>,
) {
  div("btn-group") {
    attrs {
      roleHTML = "group"
    }

    actionButton(
      icon = ButtonIconCentered(if (downloadAssemblyPortfolioBusy) "spinner-border spinner-border-sm" else FontAwesomeIcons.Download),
      classes = "btn btn-primary ${if (currentConfiguration == null) "disabled" else ""}",
      action = {
        check(currentConfiguration != null) { "Configuration must not be null to create AssemblyPortfolio" }
        setDownloadAssemblyPortfolioBusy(true)
        try {
          UiActions.downloadAssemblyPortfolioPdf(project.projectId, currentConfiguration.configurationId)
        } finally {
          setDownloadAssemblyPortfolioBusy(false)
        }
      }) {
      b("ms-2") {
        +"Montagemappe erstellen"
      }
    }

    Link {
      attrs {
        if (currentConfiguration != null) {
          toUrl = RouterUrls.project(project).configuration(currentConfiguration).moduleStrings
        } else {
          addClass("disabled")
        }
        addClass("btn btn-secondary")
      }

      i("fa-solid fa-network-wired me-2") {}
      +"Stringplan"
    }
  }
}

fun RBuilder.assemblyPortfolioRoofDownloadButtons(
  project: ResolvedProject,
  currentConfiguration: QuoteConfiguration?,
  assemblyPortfolioToSave: StateInstance<ResolvedAssemblyPortfolio>,
  downloadAssemblyPortfolioRoofBusy: Boolean,
  setDownloadAssemblyPortfolioRoofBusy: StateSetter<Boolean>,
  loggedInUser: UserInformation,
  userResolver: UserResolver,
) {
  div("btn-group") {
    attrs {
      roleHTML = "group"
    }

    actionButton(
      icon = ButtonIconCentered(if (downloadAssemblyPortfolioRoofBusy) "spinner-border spinner-border-sm" else FontAwesomeIcons.SolarPanel),
      classes = "btn btn-primary ${if (currentConfiguration == null) "disabled" else ""}",
      action = {
        check(currentConfiguration != null) { "Configuration must not be null to create AssemblyPortfolio" }
        setDownloadAssemblyPortfolioRoofBusy(true)
        try {
          UiActions.downloadAssemblyPortfolioRoofPdf(project.projectId, currentConfiguration.configurationId)
        } finally {
          assemblyPortfolioToSave.setter { it.copy(roofPdfDownloadedAt = it.roofPdfDownloadedAt.with(nowMillis(), loggedInUser.loginName)) }
          setDownloadAssemblyPortfolioRoofBusy(false)
        }
      }) {
      b("ms-2") {
        +"Montagemappe Dach"
      }
    }

    Link {
      attrs {
        if (currentConfiguration != null) {
          toUrl = RouterUrls.project(project).configuration(currentConfiguration).moduleStrings
        } else {
          addClass("disabled")
        }
        addClass("btn btn-secondary")
      }

      i("fa-solid fa-network-wired me-2") {}
      +"Stringplan"
    }
  }

  div("form-text") {
    val currentRoofEdit = assemblyPortfolioToSave.value.roofPdfDownloadedAt.currentEdit
    val roofEditor = currentRoofEdit.loginName?.let { userResolver[it] }
    if (currentRoofEdit.value != null) {
      +"Dach-Montagemappe wurde am ${dateFormat.format(currentRoofEdit.editTime, plannerI18nConfiguration)} um ${timeFormat.format(currentRoofEdit.editTime, plannerI18nConfiguration)} von "
      if (roofEditor != null) userName(roofEditor) else +"-"
      +" heruntergeladen."
    } else {
      +"Dach-Montagemappe wurde noch nicht heruntergeladen."
    }
  }
}

fun RBuilder.assemblyPortfolioBasementDownloadButtons(
  project: ResolvedProject,
  currentConfiguration: QuoteConfiguration?,
  assemblyPortfolioToSave: StateInstance<ResolvedAssemblyPortfolio>,
  downloadAssemblyPortfolioBasementBusy: Boolean,
  setDownloadAssemblyPortfolioBasementBusy: StateSetter<Boolean>,
  loggedInUser: UserInformation,
  userResolver: UserResolver,
) {
  actionButton(
    icon = ButtonIconCentered(if (downloadAssemblyPortfolioBasementBusy) "spinner-border spinner-border-sm" else FontAwesomeIcons.Bolt),
    classes = "btn btn-primary ${if (currentConfiguration == null) "disabled" else ""}",
    action = {
      check(currentConfiguration != null) { "Configuration must not be null to create AssemblyPortfolio" }
      setDownloadAssemblyPortfolioBasementBusy(true)
      try {
        UiActions.downloadAssemblyPortfolioBasementPdf(project.projectId, currentConfiguration.configurationId)
      } finally {
        assemblyPortfolioToSave.setter { it.copy(basementPdfDownloadedAt = it.basementPdfDownloadedAt.with(nowMillis(), loggedInUser.loginName)) }
        setDownloadAssemblyPortfolioBasementBusy(false)
      }
    }) {
    b("ms-2") {
      +"Montagemappe Keller"
    }
  }

  div("form-text") {
    val currentBasementEdit = assemblyPortfolioToSave.value.basementPdfDownloadedAt.currentEdit
    val basementEditor = currentBasementEdit.loginName?.let { userResolver[it] }
    if (currentBasementEdit.value != null) {
      +"Keller-Montagemappe wurde am ${dateFormat.format(currentBasementEdit.editTime, plannerI18nConfiguration)} um ${timeFormat.format(currentBasementEdit.editTime, plannerI18nConfiguration)} von "
      if (basementEditor != null) userName(basementEditor) else +"-"
      +" heruntergeladen."
    } else {
      +"Keller-Montagemappe wurde noch nicht heruntergeladen."
    }
  }
}
